var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper404"},[_c('h1',[_vm._v("Esta página no existe")]),_c('router-link',{staticClass:"btn",attrs:{"to":"/","tag":"button"}},[_vm._v("Volver a la home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }